import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { LoanOfferGenService } from "app/loan/services/loan-offer-gen.service";
import * as emiGlobals from 'app/globals';
@Component({
  selector: 'app-home-loan-transfer-page',
  templateUrl: './home-loan-transfer-page.component.html',
  styleUrls: ['./home-loan-transfer-page.component.css']
})
export class HomeLoanTransferPageComponent implements OnInit {
  extra: any;
  HomeLoanInputValue;
  showHlForm: boolean=true;
  allBankLogo: any;
  offerWithLogo = new Array();
  dummyOfferData: any;
  offerdata = new Array();
  offer_Loading =true;
  offers;
  HomeLoanLeadType = emiGlobals.leadType.HomeLoan;
  loanType = emiGlobals.HomeLoan_Transfer;
  comapre=false;

  defaultOffergeneated: boolean = false;
  offergenearted: boolean = false;


  constructor(
    private loanOfferService : LoanOfferGenService,
    private activatedRoute: ActivatedRoute,
    private route: Router
  ) {
      // Listen for quote generation
      loanOfferService.hlQuoteGenerate$.subscribe(
        data => {
          console.log("hlQuoteGenerate$",data);
          this.showHlForm=true;
          this.generateQuote(data);
        },
        error =>{
          console.log("hlQuoteGenerate",error);
        }
      );
      loanOfferService.showHomeLoanForm$.subscribe(data=>{
        this.showHlForm=true;;
         this.showTheForm(data);
      });
  }

  ngOnInit() {
    debugger
    this.loanOfferService.bankDetails()
    .subscribe((response) => {
      this.allBankLogo = response.portal_banks;
      console.log(this.allBankLogo);
    });
    this.extra = this.activatedRoute
    .queryParams
    .subscribe(params => {
      debugger
      if (Object.keys(params).length <= 0) {
        this.getDeafaultOffer();
      } else {
        console.log("not calling default offer");
      }
    });

}
ngOnDestroy(): void {
  this.extra.unsubscribe();
}

  getDeafaultOffer(){
    if (this.offerWithLogo) {
      this.offerWithLogo.length = 0;
    }
    if (this.dummyOfferData) {
      this.dummyOfferData.length = 0;
    }
    this.loanOfferService.getHomeDefaultOffers().subscribe(
        data => {
           console.log(data);
           for(let i=0;i<data.offers.length;i++){
            data.offers[i]['loanamount']='50,00,000';
          }
           this.offers = data.offers;
           this.defaultOffergeneated = true;
           this.offergenearted = false;

           this.offerdata=this.loanOfferService.getFilteredHomeBanks(data);
           this.dummyOfferData = this.offerdata;
           if (this.allBankLogo && this.dummyOfferData.length>0) {
             for (let i = 0; i < this.dummyOfferData.length; i++) {
               if (this.dummyOfferData[i]) {
                 for (let j = 0; j < this.allBankLogo.length; j++) {
     
                   if (this.dummyOfferData[i].id == this.allBankLogo[j].emi1_id) {
                     this.dummyOfferData[i]['bank_logo'] = this.allBankLogo[j].bank_logo_4_offer;
                     this.dummyOfferData[i]['whatsapp_number'] = this.allBankLogo[j].Home_whatsapp_number;
                     this.dummyOfferData[i]['whatsapp_text'] = this.allBankLogo[j].Home_whatsapp_text;
                     this.dummyOfferData[i]['messenger_id'] = this.allBankLogo[j].home_fb;
                     this.offerWithLogo.push(this.dummyOfferData[i]);
                   }
                 }
               }
             }
             this.offerdata= this.offerWithLogo;
             this.defaultOffergeneated = true;
             this.offergenearted = false;
           }
           this.offer_Loading = false;
          // this.offerdata= data.offers;
          //    this.defaultOffergeneated = true;
          //    this.offergenearted = false;
        }
      )
  }

  generateQuote(jsonData: JSON) {
    debugger
    this.HomeLoanInputValue=JSON.stringify(jsonData);
    console.log('parameters',jsonData);
    this.showHlForm=false;
    if (this.offerWithLogo) {
      this.offerWithLogo.length = 0;
    }
    if (this.dummyOfferData) {
      this.dummyOfferData.length = 0;
    }

    console.log("to API",jsonData);
    this.offer_Loading = true;
    this.loanOfferService.getHomeOffers(jsonData).subscribe(
      data => {
        console.log(data);
        for(let i=0;i<data.offers.length;i++){
          data.offers[i]['loanamount']=data.comapre.as_enquiry
        }
        this.offers = data.offers;
        this.offerdata=this.loanOfferService.getFilteredHomeBanks(data);
        this.dummyOfferData = this.offerdata;
        if (this.allBankLogo) {
          debugger
          for (let i = 0; i < this.dummyOfferData.length; i++) {
            if (this.dummyOfferData[i]) {
              for (let j = 0; j < this.allBankLogo.length; j++) {
  
                if (this.dummyOfferData[i].id == this.allBankLogo[j].emi1_id) {
                  this.dummyOfferData[i]['bank_logo'] = this.allBankLogo[j].bank_logo_4_offer;
                  this.dummyOfferData[i]['whatsapp_number'] = this.allBankLogo[j].Home_whatsapp_number;
                  this.dummyOfferData[i]['whatsapp_text'] = this.allBankLogo[j].Home_whatsapp_text;
                  this.dummyOfferData[i]['messenger_id'] = this.allBankLogo[j].home_fb;
                  this.offerWithLogo.push(this.dummyOfferData[i]);
                }
              }
            }
          }
          this.offerdata= this.offerWithLogo;
          this.defaultOffergeneated = false;
          this.offergenearted = true;
        }
        if(data.comapre){
          this.comapre = data.comapre;
        }
        this.offer_Loading = false;
      }
    )
  }
  showTheForm(data){
    this.showHlForm=data;
  } 

  showHLForm(value){
    this.loanOfferService.ShowHl(value);
    // this.route.navigate([link]
    //   ,{ relativeTo: this.activatedRoute});
  }


}



// WEBPACK FOOTER //
// ./src/app/loan/home-loan-transfer-page/home-loan-transfer-page.component.ts